module.exports = __webpack_public_path__ + "static/img/pian_hang.69bf6a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/pian_hang.png
// module id = /r30
// module chunks = 2